(function () {
  function initSliders() {
    document.querySelectorAll('.slider-steps__routine[data-slider]').forEach(function (routine) {
      if (routine.dataset.swiperInit) return;
      routine.dataset.swiperInit = 'true';

      var track = routine.querySelector('.slider-steps__steps-track');
      var scrollbar = routine.querySelector('.slider-steps__scrollbar');
      if (!track) return;

      new Swiper(track, {
        slidesPerView: 1.3,
        spaceBetween: 15,
        observer: true,
        observeParents: true,
        scrollbar: {
          el: scrollbar,
          draggable: true,
        },
        breakpoints: {
          750: {
            slidesPerView: 2.3,
            spaceBetween: 15,
          },
          990: {
            slidesPerView: 3.3,
            spaceBetween: 40,
          },
        },
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initSliders);
  document.addEventListener('shopify:section:load', initSliders);
})();
